import { ApolloClient, InMemoryCache, createHttpLink } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import config from "services/config";

const httpLink = createHttpLink({
	uri: config.graphQL,
});

const authLink = setContext((_, { headers }) => {
	const token = sessionStorage.getItem("corksy_store_access_token");

	return {
		headers: {
			...headers,
			authorization: `Bearer ${token}`,
		},
	};
});

const apolloClient = new ApolloClient({
	link: authLink.concat(httpLink),
	cache: new InMemoryCache(),
	defaultOptions: {
		watchQuery: {
			fetchPolicy: "no-cache",
			errorPolicy: "ignore",
		},
		query: {
			fetchPolicy: "no-cache",
			errorPolicy: "all",
		},
	},
});

export default apolloClient;
